import { MEETINGMANAGEMENT_URL } from "utils/constants";
import { ENDPOINTSMEETINGSMANAGEMENT } from "utils/endpoints";
import { http } from "utils/http";

export const getMeeting = (async (pageNum,  pageSize  ,searchString ,orderBy,filterlist) => await http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.list,
    method: 'get',
    params:{

        PageNumber: pageNum,
        PageSize: pageSize,
        OrderByString:orderBy,
        SearchString : searchString ,
        FilterString:filterlist,
        }
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)

export const deleteMeeting = (id) => http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.browse,
    method: 'delete',
    params:{
        id:id
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})
